import axios from "axios";

axios.defaults.baseURL = process.env.BASE_URL;

export const SetAxiosDefauls = () => {
  axios.interceptors.request.use(onRequestFulfilled, onRequestRejected);
  axios.interceptors.response.use(onResponseFulfilled, onResponseRejected);
}
const onRequestFulfilled = async(config) => {
  let token = localStorage.getItem('auth-token');
  let userId = sessionStorage.getItem('userId');
  console.log("TOkeee", token)
  // Don't clobber an Authorization the caller set explicitly (e.g. getGraphToken
  // passes the user's SSO token as the OBO assertion; the app auth-token would break it).
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`
  }
  if (userId) {
    config.headers.userId = userId;
  }
  return Promise.resolve(config);
}

const onRequestRejected = (error) => {
  console.log("errorrr", error);
  return Promise.reject(error);
}

const onResponseFulfilled = (config) => {
  return Promise.resolve(config)
}

const onResponseRejected = (error) => {
  console.log("errorrr", error);
  return Promise.reject(error);
}
